<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      v-if="order"
      style="min-width: 50%;"
    >
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Send SMS Receipt
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <phone-number-input
          :phone="deliveryPhone"
          :override-country-code="deliveryPhoneCountryCode"
          required
          @phone-changed="phoneChanged"
        />
      </q-card-section>
      <q-card-actions
        class="row q-gutter-sm justify-end q-ma-sm items-start"
      >
        <q-btn
          color="primary"
          :disable="$_.isEmpty(deliveryPhone) || $_.isEmpty(deliveryPhoneCountryCode)"
          :loading="sending"
          @click="sendSmsReceipt"
        >
          Send Now
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import PhoneNumberInput from 'src/modules/consumer/components/phone/PhoneNumberInput'

export default {
  name: 'SendSmsReceiptDialog',
  components: {
    PhoneNumberInput
  },
  data () {
    return {
      order: null,
      shown: false,
      deliveryPhone: '',
      deliveryPhoneCountryCode: '',
      sending: false
    }
  },
  watch: {
    shown () {
      // Cleanup data
      if (!this.shown) {
        this.order = null
        this.deliveryPhone = ''
        this.deliveryPhoneCountryCode = ''
      }
    }
  },
  methods: {
    show (order) {
      this.deliveryPhone = order.deliveryPhone
      this.deliveryPhoneCountryCode = order.deliveryPhoneCountryCode
      this.order = order
      this.shown = true
    },
    phoneChanged (phoneObject) {
      if (phoneObject?.isValid?.()) {
        this.deliveryPhone = phoneObject.nationalNumber
        this.deliveryPhoneCountryCode = phoneObject.country
      } else {
        this.deliveryPhone = null
        this.deliveryPhoneCountryCode = null
      }
    },
    async sendSmsReceipt () {
      this.sending = true

      try {
        const results = await this.order.sendSmsOrderReceipt(this.deliveryPhone, this.deliveryPhoneCountryCode)

        this.sending = false
        if (results.data.success) {
          this.$q.notify({
            message: 'SMS receipt sent',
            color: 'positive'
          })
        } else {
          this.$rollbar.error('Failed to send SMS receipt', results)
          this.$q.notify({
            message: 'Failed to send SMS receipt',
            color: 'negative'
          })
        }
      } catch (error) {
        this.sending = false
        this.$rollbar.error('Failed to send SMS receipt', error)
        this.$q.notify({
          message: 'Failed to send SMS receipt',
          color: 'negative'
        })
      }

      this.shown = false
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.tr-bg-grey-4) {
  background: #DDD;
}
:deep(.tr-bg-grey-5) {
  background: #BDBDBD;
}
</style>
